<div class="content">
  <button
    type="button"
    class="dismiss-button"
    (click)="dismiss()"
    title="Dismiss this report"
  >
    <span class="x"></span>
  </button>

  <div class="report-id" title="Report ordinal">
    {{report.ordinal}}
  </div>

  <button
    type="button"
    class="report"
    tabindex="0"
    (click)="view()"
    (onKeyDown)="view()"
    title="Inspect this report"
  >
    {{getDisplayText()}}
  </button>
</div>
